import React from "react";
import { useDrag } from "react-dnd";
import { Flex } from "@chakra-ui/react";
const Droppable = (props) => {
  const [collected, drag, dragPreview] = useDrag(() => ({
    type: "htxt",
    item: props.type,
  }));
  return collected.isDragging ? (
    <div ref={dragPreview} />
  ) : (
    <Flex
      cursor="pointer"
      className={props.isDisabled ? "disabled-element" : ""}
      p="2"
      bg="#F5F7F9"
      borderRadius="sm"
      align="center"
      justify="flex-start"
      w="186px"
      h="40px"
      ml={props.isEven ? "2" : "0"}
      ref={drag}
      {...collected}
    >
      {props.children}
    </Flex>
  );
};

export default Droppable;
